// 站点全局配置：品牌、导航、页脚、FAQ、联系信息
export const site = {
  name: '吃瓜视频网',
  slogan: '娱乐圈新鲜事，追星吃瓜一站搞定',
  description:
    '吃瓜视频网聚焦娱乐八卦与圈内速递，汇集明星动态、综艺片段、影视花絮及红人视频，实时更新圈内动态，让你轻松掌握娱乐圈新鲜事。',
  contact: {
    email: 'hello@chigua.video',
    phone: '400-820-8820',
    wechat: 'chiguashipin',
    weibo: '@吃瓜视频网',
  },
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '明星动态', href: '/columns/stars' },
  { label: '综艺片段', href: '/columns/variety' },
  { label: '影视花絮', href: '/columns/film' },
  { label: '红人视频', href: '/columns/red' },
  { label: '关于我们', href: '/about' },
  { label: '联系我们', href: '/contact' },
];

export const faqs = [
  {
    q: '吃瓜视频网的内容多久更新一次？',
    a: '我们的编辑团队与内容推荐机制全天候运转，圈内热点新闻会在第一时间整理上线，明星动态、综艺片段与影视花絮通常可在事件发生数小时内看到相关速递。',
  },
  {
    q: '视频可以免费观看吗？',
    a: '可以，网站内的所有栏目视频均免费开放浏览，无需注册即可观看。部分深度专题与长视频内容可注册账号后收藏与追更，方便随时回顾。',
  },
  {
    q: '如何投稿或推荐吃瓜素材？',
    a: '如果你掌握新鲜的一手圈内资讯、拍摄到精彩现场画面，欢迎通过「联系我们」页面向我们投稿。经审核采用的内容会注明来源并署名推荐人。',
  },
  {
    q: '视频画质和加载速度怎么样？',
    a: '我们针对不同网络环境提供多档清晰度切换，并在全球节点做了内容分发加速，确保手机端也能流畅观看高清综艺与影视片段。',
  },
  {
    q: '吃瓜视频网支持手机和电脑吗？',
    a: '网站为响应式设计，电脑、平板与手机浏览器均可直接访问，移动端会自适应排版并提供完整的栏目浏览、搜索与播放体验。',
  },
  {
    q: '如何联系客服处理版权或反馈问题？',
    a: '如涉及版权或需提交内容反馈，可通过联系我们页面提交表单，也可发送邮件至 hello@chigua.video，我们通常会在 1 个工作日内回复。',
  },
];